export const mixHexColors = (color1, color2, percentage) => {
    // Ensure percentage is between 0 and 1
    percentage = Math.min(Math.max(percentage, 0), 1);

    // Convert hex to RGB
    const hexToRgb = hex => {
        hex = hex.replace(/^#/, '');
        if (hex.length === 3) {
            hex = hex.split('').map(c => c + c).join('');
        }
        const bigint = parseInt(hex, 16);
        return {
            r: (bigint >> 16) & 255,
            g: (bigint >> 8) & 255,
            b: bigint & 255,
        };
    };

    // Convert RGB to hex
    const rgbToHex = ({ r, g, b }) => {
        const toHex = c => c.toString(16).padStart(2, '0');
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };

    const rgb1 = hexToRgb(color1);
    const rgb2 = hexToRgb(color2);

    // Mix the RGB values
    const mixed = {
        r: Math.round(rgb1.r + (rgb2.r - rgb1.r) * percentage),
        g: Math.round(rgb1.g + (rgb2.g - rgb1.g) * percentage),
        b: Math.round(rgb1.b + (rgb2.b - rgb1.b) * percentage),
    };

    return rgbToHex(mixed)
}